<template>
  <div class="to-pay-floating-bar">
    <div v-if="pointContent" class="left">
      {{ pointContent }}
    </div>
    <div class="right">
      <p class="spec">
        <span class="store-count">共{{ orderStoreSum }}家药店：</span>
        <span class="total-price">¥{{ (orderAmount / 100) | toThousands }}</span>
      </p>
      <p class="btn" @click="onBtnClick">{{ btnText }}</p>
    </div>
  </div>
</template>

<script>
import { toThousands } from '@/util/index.js';
import { mapState, mapActions } from 'vuex';
export default {
  name: 'toPayFloatingBar',
  props: {
    pointType: {
      type: Number,
      default: 1 // 1:下订单提醒，2:支付发票提醒
    },
    pointShow: {
      type: Boolean,
      default: false
    },
    orderStoreSum: {
      type: Number,
      default: 0
    },
    orderAmount: {
      type: Number,
      default: 0
    },
    btnText: {
      type: String,
      default: ''
    }
  },
  computed: {
    ...mapState('global', ['saleInfo']),
    pointContent() {
      const { pointShow, pointType, saleInfo = {} } = this;
      const { saleName, saleMobile } = saleInfo;
      if (!pointShow) return '';
      const pointTypeObj = {
        1: '如有疑问请联系您的业务经理',
        2: '*如需发票请联系您的业务经理'
      };
      if (saleName || saleMobile) {
        return `${pointTypeObj[pointType]}：${saleName || ''} ${saleMobile || ''}`;
      }
      return `${pointTypeObj[pointType]}`;
    }
  },
  data() {
    return {
      key: ''
    };
  },
  created() {
    this.getSaleInfo();
  },
  methods: {
    ...mapActions('global', ['getSaleInfo']),
    onBtnClick() {
      this.$emit('btnClick');
    }
  },
  filters: {
    toThousands
  }
};
</script>

<style lang="scss" scoped>
.to-pay-floating-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 24px;
  position: fixed;
  z-index: 7;
  bottom: 0;
  right: 0;
  left: 240px;
  height: 56px;
  background: #ffffff;
  box-shadow: 0px -3px 8px 0px rgba(0, 0, 0, 0.06);
  font-size: 14px;
  font-weight: 400;
  color: #595959;
  .right {
    display: flex;
    flex: 1;
    justify-content: flex-end;
    align-items: center;
    .total-price {
      font-weight: 600;
      color: #262626;
    }
    .btn {
      width: 100px;
      height: 40px;
      text-align: center;
      margin-left: 16px;
      line-height: 40px;
      background: #1e8dff;
      border-radius: 4px;
      font-size: 14px;
      color: #ffffff;
    }
  }
}
</style>
